import { Component } from '@theme/component';

class GreenReviewPlayer extends Component {
  #controller;
  #observer;
  #slider;
  #timer;
  #visible = false;

  async connectedCallback() {
    super.connectedCallback();
    this.#controller?.abort();
    clearInterval(this.#timer);
    this.#observer?.disconnect();
    this.#visible = false;
    const controller = new AbortController();
    this.#controller = controller;
    await customElements.whenDefined('slideshow-component');
    if (!this.isConnected || controller.signal.aborted) return;
    this.#slider = this.querySelector('slideshow-component');
    if (!this.#slider) return;
    const slider = this.#slider;
    const motion = matchMedia('(prefers-reduced-motion: reduce)');
    const { signal } = controller;
    const stop = () => { clearInterval(this.#timer); this.#timer = undefined; };
    const start = () => {
      stop();
      if (!this.#visible || document.hidden || window.Shopify?.designMode ||
          this.dataset.autoplay !== 'true' || this.matches(':hover, :focus-within')) return;
      this.#timer = setInterval(() => {
        const scroller = slider.querySelector('slideshow-slides');
        if (!scroller || slider.slides.length < 2) return;
        const atEnd = Math.abs(scroller.scrollLeft) >= scroller.scrollWidth - scroller.clientWidth - 2;
        slider.select(atEnd ? 0 : slider.current + 1, undefined, { animate: !motion.matches });
      }, Math.max(2000, Number(this.dataset.interval) || 2000));
    };
    this.addEventListener('mouseenter', stop, { signal });
    this.addEventListener('mouseleave', start, { signal });
    this.addEventListener('focusin', stop, { signal });
    this.addEventListener('focusout', () => queueMicrotask(start), { signal });
    this.addEventListener('touchstart', stop, { signal, passive: true });
    this.addEventListener('touchend', start, { signal, passive: true });
    document.addEventListener('visibilitychange', start, { signal });
    motion.addEventListener('change', start, { signal });
    this.addEventListener('shopify:block:select', (event) => {
      stop();
      const slide = event.target.closest('slideshow-slide');
      if (slide) slider.select({ id: slide.getAttribute('slide-id') }, undefined, { animate: false });
    }, { signal });
    this.#observer = new IntersectionObserver(([entry]) => {
      this.#visible = entry.isIntersecting;
      start();
    }, { threshold: 0.25 });
    this.#observer.observe(this);
  }

  updatedCallback() {
    super.updatedCallback();
    this.connectedCallback();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#controller?.abort();
    this.#observer?.disconnect();
    clearInterval(this.#timer);
  }
}

if (!customElements.get('green-review-player')) customElements.define('green-review-player', GreenReviewPlayer);
